import { createReducer } from './../../service/Utils';

const initialState = {
  seconds: 0
};

export default createReducer(initialState, {
  TICK: (state, payload) => {
    return { ...state, seconds: payload };
  },
  REAUTH: (state) => {
    return state;
  }
});
